"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sink = void 0;
exports.sink = sink;
var _nodeStream = require("node:stream");
class Sink extends _nodeStream.Writable {
  constructor(options = {}) {
    super({
      objectMode: true,
      ...options
    });
  }
  _write(_chunk, _encoding, callback) {
    callback();
  }
  _final(callback) {
    callback();
  }
}
exports.Sink = Sink;
function sink() {
  return new Sink();
}